import React, { useEffect, useState } from 'react'
import { Link, useParams ,useNavigate  } from 'react-router-dom'
import "./login.css"
import { useDispatch, useSelector } from 'react-redux'
import { toast  } from 'react-toastify'
import { getResetPasswordApi, ResetPasswordApi } from '../../redux/apiCalls/passwordApiCall'


function ResetPassword() {

   const [password, setPasword] = useState("")
   const {isError} = useSelector(state => state.password)
   const dispatch = useDispatch();

   const {userId, token} = useParams();
   const navigate = useNavigate();


   useEffect(()=>{
    dispatch(getResetPasswordApi(userId,token))
   },[userId,token]);

   // Form Submit Handler
   const formSubmitHandler = (e)=>{
    e.preventDefault();
    console.log("Submitting...");


    if(password.trim() ==="") return toast.error("Password is required");
    dispatch(ResetPasswordApi(password,{userId,token},navigate));

   }

  return (
    <main className="login-page">
      <div className="login-card">

        {isError ? ( <h1 className="login-title">Not Found</h1>  ): ( <>
          <h1 className="login-title">Reset Password</h1>
        {/* <p className="login-subtitle">Please Enter new Password</p> */}



        <form onSubmit={formSubmitHandler} className="login-form">
         
          <div className="login-field">
            <label htmlFor="login-password">Enter New Password</label>
            <input
              id="login-password"
              type="password"
              placeholder="••••••••"
              value={password}
              onChange={(e)=> setPasword(e.target.value)}
            />
          </div>
          
          <button type="submit" className="login-submit">
            Submit
          </button>
        </form>
        
        </> )}
     

        
      </div>
    </main>
  )
}

export default ResetPassword